import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export function useChangePassword() {
  return useMutation({
    mutationFn: async (body: { old_password: string; new_password: string }) => {
      const { error } = await apiClient.POST("/v1/auth/change-password", { body });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
    },
  });
}
